import { useCallback, useEffect, useState } from 'react';
import { getLearningProgress } from '../services/learningProgress';
import { isSubscriptionRequiredError } from '../utils/authSession';

export function useLearningProgress(categoryId, performancePeriod = 'this_week', enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [subscriptionRequired, setSubscriptionRequired] = useState(false);

  const fetchProgress = useCallback(async () => {
    if (!enabled || !categoryId) {
      setData(null);
      setSubscriptionRequired(false);
      return;
    }

    setLoading(true);
    setError(null);
    setSubscriptionRequired(false);

    try {
      const res = await getLearningProgress({ categoryId, performancePeriod });

      if (res?.success === false && isSubscriptionRequiredError(res?.message)) {
        setSubscriptionRequired(true);
        setError(null);
        setData(null);
        return;
      }

      setData(res?.data || null);
    } catch (e) {
      const message = e?.message || 'Failed to load learning progress';

      if (isSubscriptionRequiredError(message)) {
        setSubscriptionRequired(true);
        setError(null);
      } else {
        setError(message);
        setSubscriptionRequired(false);
      }

      setData(null);
    } finally {
      setLoading(false);
    }
  }, [categoryId, enabled, performancePeriod]);

  useEffect(() => {
    void fetchProgress().catch(() => {});
  }, [fetchProgress]);

  return { data, loading, error, subscriptionRequired, refetch: fetchProgress };
}
